import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 14c-1.1 0-2.1.5-2.8 1.2l-5.3-3.1c0-.4.1-.7.1-1.1s-.1-.7-.2-1.1l5.3-3.1c.8.7 1.8 1.2 2.9 1.2 2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4c0 .4.1.7.2 1.1L6.8 8.2C6.1 7.5 5.1 7 4 7c-2.2 0-4 1.8-4 4s1.8 4 4 4c1.1 0 2.1-.5 2.8-1.2l5.3 3.1c0 .4-.1.7-.1 1.1 0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4m0-12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2M4 13c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m12 7c-1.1 0-2-.9-2-2 0-.4.1-.7.3-1 .3-.6 1-1 1.7-1 1.1 0 2 .9 2 2s-.9 2-2 2"
    }, null, -1)
  ]))]))
}
export default { render: render }